var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useSelector } from 'react-redux';
import { ScreenContainer, LayoutContentHeader, LayoutContent, Button, } from '@pinwheel/origami';
import ModalHeader from '../../components/ModalHeader';
import { useOpts } from '../../context';
import { selectCurrentSource, selectLastSource, } from '../../state/slices/slice-segment';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { usePIIDataContext } from '../../hooks/usePIIDataContext';
import DetailsTable from '../../LinkApiRouter/components/Table/DetailsTable';
import { EventAction, EventType } from '../../types/events';
import { useAppDispatch, useAppSelector } from '../../state';
import { postUserAuthenticationFields, selectLoading, } from '../../state/slices/slice-link-api';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { selectLinkParams } from '../../state/slices/slice-link-params';
import LoadingView from '../../views/Loading';
var PIIDataReview = function () {
    var _a = usePIIDataContext(), tel = _a.tel, dob = _a.dob, ssn4 = _a.ssn4, ssn9 = _a.ssn9, goBack = _a.goBack;
    var getLocalizedString = useGetLocalizedString();
    var _b = useOpts(), fireUnifiedEvent = _b.fireUnifiedEvent, modalSessionId = _b.modalSessionId, uniqueUserId = _b.uniqueUserId;
    var linkParams = useAppSelector(selectLinkParams);
    var isLoading = useAppSelector(selectLoading);
    var navigate = useLinkNavigate();
    var currentSource = useSelector(selectCurrentSource);
    var lastSource = useSelector(selectLastSource);
    var dispatch = useAppDispatch();
    var handleSubmit = function () {
        fireUnifiedEvent(EventType.LINK_COLLECT_PII_DATA_EVENT, {
            action: EventAction.CONTINUE,
            entry_point: lastSource,
            source: currentSource,
        });
        void dispatch(postUserAuthenticationFields({
            linkToken: linkParams.linkToken,
            modalSessionId: modalSessionId || '',
            uniqueUserId: uniqueUserId,
            sdk: linkParams.sdk || '',
            sdkVersion: "".concat(linkParams.version.major, ".").concat(linkParams.version.minor, ".").concat(linkParams.version.patch),
            data: {
                social_security_number_last_four: ssn4,
                date_of_birth: dob,
                mobile_phone_number: tel,
            },
        })).then(function () {
            navigate('/multi-supplier-eligibility/lookup');
        });
    };
    return isLoading ? (React.createElement(LoadingView, null)) : (React.createElement(ScreenContainer, { "data-testid": "ScreenContainer" },
        React.createElement(ModalHeader, { onBack: goBack }),
        React.createElement(LayoutContentHeader, { title: getLocalizedString('LETS_FIND_YOUR_PAYROLL_ACCOUNT'), subtitle: getLocalizedString('PLEASE_REVIEW_AND_CONFIRM_THESE_DETAILS') }),
        React.createElement(LayoutContent, null,
            React.createElement(DetailsTable, { data: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (tel
                    ? [
                        {
                            label: getLocalizedString('TELEPHONE_NUMBER'),
                            value: tel,
                        },
                    ]
                    : []), true), (dob
                    ? [
                        {
                            label: getLocalizedString('BIRTHDATE'),
                            value: dob,
                        },
                    ]
                    : []), true), (ssn4
                    ? [
                        {
                            label: getLocalizedString('SOCIAL_SECURITY_NUMBER_LAST_4'),
                            value: ssn4,
                        },
                    ]
                    : []), true), (ssn9
                    ? [
                        {
                            label: getLocalizedString('SOCIAL_SECURITY_NUMBER'),
                            value: ssn9,
                        },
                    ]
                    : []), true) }),
            React.createElement(Button, { eventId: "PIIData-review", "data-testid": "button", onClick: handleSubmit }, getLocalizedString('LOOK_UP_ACCOUNT')))));
};
export default PIIDataReview;
